import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Outlet, Route, Switch, useHistory, useLocation, useNavigate, useRouteMatch } from 'react-router-dom';
import toast from 'react-hot-toast';
import Footer from '../shared/Footer/Footer';
import MenuBar from '../shared/MenuBar/MenuBar';
import { Button, Card, Col, Row } from 'react-bootstrap';
import CompareCars from './CompareCars';

const Compare = () => {

    const { state } = useLocation();
    const { chooseBlog } = state;
    const [blogs, setBlogs] = useState([]);
    const [blog1, setBlog1] = useState(null);
    const [blog2, setBlog2] = useState(null);
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    
    let { path, url } = useRouteMatch();
    useEffect(() => {
        axios.get("https://safe-crag-22535.herokuapp.com/availableCars")
            .then(({ data }) => {
                setBlogs(data)
                setLoading(false)
                if (chooseBlog) {
                    setBlog1(chooseBlog);
                }
            }).catch(err => console.log(err.message))
    }, [])
    const handleChooseBlog1 = (blog) => {
        let obj = JSON.parse(blog);
        setBlog1(obj)
    }
    const handleChooseBlog2 = (blog) => {
        let obj = JSON.parse(blog);
        setBlog2(obj)
    }
    const handleCompare = async () => {
        if (blog1 === null && blog2 === null) {
            return toast.error("Plase Choose a Blog")
        } else if (blog2 === null || blog1 === null) {
            return toast.error("Chose another Blog")
        } else {
            toast.loading("Please wait...")
            const chooseCars = await [blog1, blog2];
            // await setCompareBlogs([blog1, blog2])
            toast.dismiss();
            history.push({
                pathname: `${url}/cars`,
                state: {chooseCars}
            })
        }
    }
    console.log("chose1", blog1, "chose2", blog2);
    return (
        <div className="compare-section">
            <MenuBar />
            {/* <CompareBanner /> */}
            <div style={{ padding: "150px 0" }} className="choose-blog md:container flex justify-center mx-auto px-20 py-8">
                {
                    loading ?
                        <div>
                            <div style={{ borderTopColor: "transparent" }} className="w-16 h-16 border-4 border-blue-400 border-dashed rounded-full animate-spin"></div>
                        </div>
                        :

                        <div class="container flex justify-center mx-auto">
                            <Row>
                                <Col md={6} sm={12}>
                                    <Card style={{ width: '18rem' }}>
                                        <Card.Img variant="top" src={blog1?.img} />
                                        <Card.Body>
                                            <Card.Title>{blog1?.name}</Card.Title>
                                            <Card.Text>
                                                {blog1?.transmission}
                                            </Card.Text>
                                            
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <div class="flex flex-col py-3">
                                <div class="w-full">
                                    <span
                                        className="md:container mx-auto grid grid-cols-2 gap-4 px-2 py-8 text-xs font-semibold leading-5  rounded-full">

                                        <select type="select"
                                            className={`${"text-base w-full border bg-white rounded px-3 py-2 outline-none"}`}
                                            blogs={blogs}
                                            onChange={(e) => handleChooseBlog2(e.target.value)}
                                        >
                                            {blogs.map((blog, index) => (
                                                <option
                                                    value={JSON.stringify(blog)}
                                                    className='block px-4 py-2 text-sm  text-gray-700 hover:bg-gray-400 hover:text-white'
                                                >{blog.name}

                                                </option>


                                            ))}
                                        </select>
                                    </span>
                                    <Button onClick={handleCompare} variant="success">Comparing</Button>
                                    <div className="compare-outlet">
                                    <Switch>
                                    <Route path={`${path}/cars`}>
                                        <CompareCars />
                                    </Route>
                                    </Switch>
                                    </div>
                                    {/* <Outlet /> */}
                                </div>
                            </div>
                        </div>
                }
            </div>
            <Footer />
        </div>
    );
};

export default Compare;